<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 col-md-6"> 
          <stats-card class="card-danger" v-if="emEspera > 0">
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-time-alarm text-white"></i>
            </div>
            <div slot="content">
              <p class="card-category">Manifestacões em Espera</p>
              <h4 class="card-title">{{emEspera}}</h4>
            </div>
            <div slot="footer" >
              <router-link to="Manifestacao" style="color: #fff " ><i class="fa fa-eye"></i>Visualizar Manifestações</router-link>
            </div>
          </stats-card>

          <stats-card v-else>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-time-alarm text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Manifestacões em Espera</p>
              <h4 class="card-title">{{emEspera}}</h4>
            </div>
            <div slot="footer" >
              <router-link to="Manifestacao" style="color: #adadad " ><i class="fa fa-eye"></i>Visualizar Manifestações</router-link>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-notes text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Manifestacões Abertas</p>
                <h4 class="card-title"  >
                    {{emAberto}}
                </h4>
            </div>
            <div slot="footer" >
              <router-link to="Manifestacao" style="color: #adadad " ><i class="fa fa-eye"></i>Visualizar Manifestações</router-link>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6" v-show="user.tipo == 1 || user.tipo == 2">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-check-2 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Manifestacões Fechadas</p>
                <h4 class="card-title"  >
                  {{emFinalizada}}
                </h4>
            </div>
            <div slot="footer" >
            </div>  
          </stats-card>
        </div>

        <div class="col-md-12" v-if="emEspera > 0">
          <h3>Notificações de Manifestações em Espera</h3>
          <div v-for="a in this.manifestacao" :key="a.uuid">
            <div class="alert alert-danger" role="alert" v-if="a.abertura == 'Espera'">
              <router-link to="Manifestacao" style="color: #ffffff;text-transform: uppercase;">
                <h4 style="margin: 15px 0 15px;">{{a.assunto}}</h4>
                <h5 style="font-weight:700"> {{a.tipo_assunto}}</h5>
              </router-link>
            </div> 
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios';
  import store from "src/store.js"
  import 'src/controller/sistema/manifestacaoController.js'

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        i:0,
        projetos_cont_votacao:0,
        token:null,
        vereadores:[],
        projetos:[],
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        pieChart: {
          data: {
            labels: ['40%', '20%', '40%'],
            series: [40, 20, 40]
          }
        },
        lineChart: {
          data: {
            labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
            series: [
              [287, 385, 490, 492, 554, 586, 698, 695],
              [67, 152, 143, 240, 287, 335, 435, 437],
              [23, 113, 67, 108, 190, 239, 307, 308]
            ]
          },
          options: {
            low: 0,
            high: 800,
            showArea: false,
            height: '245px',
            axisX: {
              showGrid: false
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        barChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            series: [
              [2, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
              [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
            ]
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        tableData: {
          data: [
            {title: 'Sign contract for "What are conference organizers afraid of?"', checked: false},
            {title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true},
            {
              title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              checked: true
            },
            {title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false},
            {title: 'Read "Following makes Medium better"', checked: false},
            {title: 'Unfollow 5 enemies from twitter', checked: false}
          ]
        },
        manifestacao:[],
        emEspera:0,
        emAberto:0,
        emFinalizada:0,
        user: {
          admin: null,
          admin_sistema: null,
          grupo: null,
          departamento:null,
          tipo: null,
        },
        permiss:[],
        minha:{
         cidadao: 1,
         manifestacao: 1,
         editor: 1,
         mod_departamento:1,
       },
      }
    },
    methods: {
       async manifestaçoes(){
           try {
              let data =[];

              this.user.departamento = this.user.departamento.toString();
              let dep = this.user.departamento.split('-');
              if(dep[0] == ''){
                dep.shift();
              }
              this.user.departamento = dep;
              let count = this.user.departamento.length;

              console.log(count);

              if(count == 1){
                if (this.user.departamento == 0 || this.user.departamento == 1) {
                  data = await this.$listarManifestos();
                } else {
                  data = await this.$listarManifestosPorDepartamento(
                    this.user.departamento
                  );
                }

                this.manifestacao = data.data.reverse();
              }else{
                data = [];
                for (let departamento of this.user.departamento) {
                    let d = await this.$listarManifestosPorDepartamento(departamento);
                    for (let index = 0; index < d.data.length; index++) {
                      let element = d.data[index];
                      data.push(element);
                    }
                    
                }
                this.manifestacao = data;
              }

              this.manifestacao.forEach(element => {
                 if(element.abertura =="Espera"){
                   this.emEspera++;
                 }
                 else if(element.abertura =="Aberta"){
                   this.emAberto++;
                 }
                 else if(element.abertura =="Finalizada"){
                   this.emFinalizada++;
                 }
              });
           } catch (e) {
              //console.log(e);
           }
       },
       
       async permissao() {
        try {
          let data = await this.$listarPermissoes();
          this.permiss = data.data;

          this.permiss.forEach((element) => {
            if (store.grupo == element.id) {
              this.minha.cidadao = element.hab_cidadao;
              this.minha.manifestacao = element.hab_manifestacao;
              this.minha.mod_departamento = element.hab_mod_departamento;
            }
          });

        }catch(e){

        }
      }
    },
    beforeMount(){
       this.user.admin = store.admin;
       this.user.admin_sistema = store.admin_sistema;
       this.user.grupo = store.grupo;
       this.user.departamento = store.departamento;
       this.user.tipo = store.tipo;
       this.permissao();
       this.manifestaçoes();
       
    }

  }
</script>
<style>
.main-panel .footer{
 display: none;
}
.card-danger{
  background-color:#fc727a;
}

.card-danger .card-category{
    color: #ffffff;
} 

.card-danger .card-title {
  color: #ffffff;
}


/*.card-danger-b {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}*/
</style>
